import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
  CircularProgress,
  TextField,
  Box,
  Pagination,
} from '@mui/material';
import { fetchAllCustomersRequest } from '../../redux/Customers/actions/customerActions';

import TextInputField from '../../component/ui/FormFields/TextInputField';
import { SearchIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { INSTANT_BOOKING_AIRPORT_DETAILS } from '../../component/common/Routes/AppRoutes';

const CustomerSelectionDialog = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const { customers: response, loading } = useSelector(
    (state) => state.customers
  );
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [showNewCustomerForm, setShowNewCustomerForm] = useState({
    open: false,
    customerDetails: null,
  });

  const [search, setSearch] = useState('');

  useEffect(() => {
    if (open) {
      dispatch(fetchAllCustomersRequest());
    }
  }, [dispatch, open, page, rowsPerPage]);

  const handleCustomerSelect = (customer) => {
    navigate(INSTANT_BOOKING_AIRPORT_DETAILS, {
      state: {
        customerDetails: customer,
      },
    });
    onClose();
  };

  const handleClose = () => {
    setShowNewCustomerForm(false);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };
  const activeCustomers = response?.data?.filter((customer) => {
    if (customer?.status === 0) {
      return {
        customer,
      };
    }
  });
  const filteredCustomers = activeCustomers?.filter((customer) =>
    `${customer.first_name} ${customer.last_name} ${customer.email} ${customer.phone}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );
  const paginatedData = useMemo(() => {
    return filteredCustomers.slice(
      (page - 1) * rowsPerPage,
      page * rowsPerPage
    );
  }, [filteredCustomers, page, rowsPerPage]);

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
        <DialogTitle>Select Customer</DialogTitle>
        <DialogContent>
          <Box sx={{ marginTop: '10px', marginBottom: '20px' }}>
            <TextInputField
              fullWidth
              label={'Search Customers'}
              variant='outlined'
              placeholder={'Search Customer'}
              startAdornment={<SearchIcon />}
              size='small'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Box>

          {loading ? (
            <CircularProgress />
          ) : (
            <>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Phone</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedData.length > 0 ? (
                    paginatedData.map((customer) => (
                      <TableRow key={customer.id}>
                        <TableCell>{`${customer.first_name} ${customer.last_name}`}</TableCell>
                        <TableCell>{customer.email}</TableCell>
                        <TableCell>{customer.phone}</TableCell>
                        <TableCell>
                          <Button
                            sx={{ backgroundColor: '#ed6c02' }}
                            variant='contained'
                            size='small'
                            onClick={() => handleCustomerSelect(customer)}
                          >
                            Select
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} align='center'>
                        No Customers Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>

              <Box mt={2} display='flex' justifyContent='end'>
                <Pagination
                  count={Math.ceil(filteredCustomers.length / rowsPerPage)}
                  page={page}
                  onChange={handleChangePage}
                  color='primary'
                />
              </Box>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CustomerSelectionDialog;
